var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Col, Container, Row } from 'react-grid-system';
import { translate } from 'react-i18next';
import Page from '../../../containers/Page';
import { Button as MButton, FormDropdown } from '@bytebrand/fe-ui-core-autobahn/ui';
import ColItem from '../../../ui/ColItem/ColItem';
import HeaderBlock from '../blocks/HeaderBlock/HeaderBlock';
import FieldDescriptionBlock from '../blocks/FieldDescriptionBlock/FieldDescriptionBlock';
import form, { fieldsNames } from '../forms/DataImportForm';
import styles from './DataImportPage.styl';
var Stage;
(function (Stage) {
    Stage[Stage["UNSELECTED"] = 0] = "UNSELECTED";
    Stage[Stage["SELECTION"] = 1] = "SELECTION";
    Stage[Stage["SELECTED"] = 2] = "SELECTED";
})(Stage || (Stage = {}));
const col12 = 12;
const col9 = 9;
const col8 = 8;
const col6 = 6;
const col4 = 4;
let DataImportPage = class DataImportPage extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, profileStore: { patchDealerProfileEdit, saveDealerProfileEdit, clearDealerProfile, getDealerProfile }, notificationStore: { addNotification } } = this.props;
                form.each((field) => field.set('disabled', true));
                form.submit({
                    onSuccess: (form) => {
                        const { legacyApiPartner } = form.values();
                        patchDealerProfileEdit({ legacyApiPartner });
                        saveDealerProfileEdit(undefined)
                            .then(clearDealerProfile)
                            .then(getDealerProfile)
                            .then(() => {
                            this.setState({ stage: Stage.SELECTED });
                            addNotification({
                                message: t('message.success.full', { legacyApiPartner }),
                                level: 'success'
                            });
                        })
                            .catch(({ errors }) => {
                            if (Array.isArray(errors)) {
                                errors.forEach(({ detail }) => {
                                    if (detail) {
                                        addNotification({
                                            message: detail,
                                            level: 'error'
                                        });
                                    }
                                });
                            }
                        })
                            .finally(() => {
                            form.each((field) => field.set('disabled', false));
                        });
                    },
                    onError: (form) => {
                        form.each((field) => field.set('disabled', false));
                    }
                });
            }
        });
        this.state = {
            stage: Stage.UNSELECTED
        };
    }
    componentDidMount() {
        const { profileStore: { getApiPartners, getDealerProfileEdit } } = this.props;
        const field = form.$(fieldsNames.legacyApiPartner);
        const value = (value) => ({ value, label: value });
        form.each((field) => field.set('disabled', true));
        getDealerProfileEdit().then((dealerProfileEdit) => {
            const { legacyApiPartner } = dealerProfileEdit;
            if (legacyApiPartner !== null && legacyApiPartner !== undefined) {
                field.set('value', value(legacyApiPartner));
                this.setState({ stage: Stage.SELECTED });
            }
        }).then(getApiPartners).then((apiPartners) => {
            form.each((field) => field.set('disabled', false));
            field.set('extra', apiPartners.map(value));
        });
    }
    componentWillUnmount() {
        const { profileStore: { clearDealerProfileEdit } } = this.props;
        clearDealerProfileEdit();
        form.each((field) => {
            field.clear(false);
            field.set('disabled', false);
        });
    }
    render() {
        const { t, profileStore, authStore } = this.props;
        const { stage } = this.state;
        const { isFetching, isSaving, dealerProfileEdit } = toJS(profileStore);
        const { firebaseUser } = toJS(authStore);
        const userId = firebaseUser.user_id;
        const placeholderTextArray = t(`text.${fieldsNames.legacyApiPartner}.desc.general`, { returnObjects: true });
        placeholderTextArray[2] = placeholderTextArray[2].replace(`{owner_id}`, userId);
        const body = (React.createElement(Container, { fluid: true, className: styles.importPageContainer },
            React.createElement(Row, null,
                React.createElement(Col, { xs: col12 },
                    React.createElement(HeaderBlock, { textHeader: t('header.page'), headerStyle: styles.importHeader }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: col12, md: col6 },
                    React.createElement(Row, null,
                        React.createElement(ColItem, { xs: col12, border: true },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: col12, lg: col9 },
                                    React.createElement("div", { className: styles.textSubheader }, t(`subheader.${fieldsNames.legacyApiPartner}`)))),
                            React.createElement(Row, null, !isFetching ? {
                                [Stage.UNSELECTED]: () => (React.createElement(React.Fragment, null,
                                    React.createElement(Col, { xs: col12, lg: col9 },
                                        React.createElement("div", { className: styles.textLabel }, t(`text.${fieldsNames.legacyApiPartner}.unselected`))),
                                    React.createElement(Col, { xs: col12, lg: col9 },
                                        React.createElement(Row, null,
                                            React.createElement(Col, { xs: col12, md: col8, offset: { md: col4 } },
                                                React.createElement(MButton, { variant: 'filled', className: styles.button, icon: 'plus', onClick: () => this.setState({ stage: Stage.SELECTION }) }, t('ui.button.add'))))))),
                                [Stage.SELECTION]: () => (React.createElement(React.Fragment, null,
                                    React.createElement(Col, { xs: col12, lg: col9 },
                                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 12 } },
                                            React.createElement("div", { className: styles.text },
                                                t(`label.${fieldsNames.legacyApiPartner}`),
                                                ":"),
                                            React.createElement("div", { style: { flex: 1 } },
                                                React.createElement(FormDropdown, { t: t, field: form.$(fieldsNames.legacyApiPartner) })))),
                                    React.createElement(Col, { xs: col12, lg: col9 },
                                        React.createElement(Row, null,
                                            React.createElement(Col, { xs: col12, md: col8, offset: { md: col4 } },
                                                React.createElement(MButton, { variant: 'filled', className: styles.button, disabled: isSaving, onClick: this.onSave }, isSaving
                                                    ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } })
                                                    : t('ui.button.save'))))))),
                                [Stage.SELECTED]: () => (React.createElement(React.Fragment, null,
                                    React.createElement(Col, { xs: col12, lg: col9 },
                                        React.createElement(Row, null,
                                            React.createElement(Col, { xs: col4 },
                                                React.createElement("div", { className: styles.textLabel },
                                                    t(`label.${fieldsNames.legacyApiPartner}`),
                                                    ":")),
                                            React.createElement(Col, { xs: col8 },
                                                React.createElement("div", { className: styles.textLabel }, dealerProfileEdit.legacyApiPartner)),
                                            React.createElement(Col, { xs: col12, md: col8, offset: { md: col4 } },
                                                React.createElement(MButton, { variant: 'filled', className: styles.button, onClick: () => this.setState({ stage: Stage.SELECTION }) }, t('ui.button.edit')))))))
                            }[stage]() : (React.createElement(Col, { xs: col12 },
                                React.createElement("span", { className: 'auth-spinner', style: { margin: '19px auto 8px', display: 'block' } })))),
                            React.createElement(Row, null,
                                React.createElement("span", { className: styles.dealerId },
                                    t('user.userId'),
                                    " : ",
                                    userId))))),
                React.createElement(Col, { xs: col12, md: col6 },
                    React.createElement(FieldDescriptionBlock, { title: t(`text.${fieldsNames.legacyApiPartner}.desc.title`), texts: placeholderTextArray })))));
        return React.createElement(Page, { page: 'DATA_IMPORT' },
            React.createElement("div", { className: "md3" }, body));
    }
};
DataImportPage = __decorate([
    inject('profileStore', 'notificationStore', 'authStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], DataImportPage);
export default translate('DataImportPage')(DataImportPage);
